/** @format */

import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router'
import { _$, Menu, MenuItem, MenuTitle, Divider } from '@king-design/react'
import styled from 'styled-components'
import useGlobalData from 'src/hooks/useGlobalData'
const RouterBar = props => {
  const productMenu = useGlobalData('productMenu')
  const path = props.location.pathname
  // 主题色
  const [theme, setTheme] = useState<'light' | 'dark' | 'white'>('light')
  // 选中菜单
  const [key, setKey] = useState<string | undefined>()
  // 展开菜单
  const [expandedKeys, setexpandedKeys] = useState<string[]>([])
  useEffect(() => {
    if (path.indexOf('/monitor/list/overview/') >= 0 || path.indexOf('/monitor/list/') >= 0) {
      setKey('/monitor/menu')
    } else {
      setKey(undefined)
    }
  }, [path])

  useEffect(() => {
    let windowRegion
    window['__ksStorage__']?.on('theme', data => {
      setTheme(data)
    })
    return () => {
      windowRegion && windowRegion.remove()
    }
  }, [])

  return (
    <div className={props.className}>
      {productMenu?.length ? (
        <Menu
          size="small"
          slotHeader={<>{_$('云监控')}</>}
          onChangeCollapse={val => {
            props.setMenuState(val)
          }}
          expandedKeys={expandedKeys}
          onChangeExpandedKeys={expandedKeys => setexpandedKeys(expandedKeys)}
          selectedKey={key || props.location.pathname}
          collapse={props.menuState}
          showCollapseArrow={true}
          theme={theme}
        >
          <MenuItem key="/monitor/generalview/home" to="/monitor/generalview/home">
            {_$('概览')}
          </MenuItem>
          <MenuItem key="/monitor/menu" to="/monitor/menu">
            {_$('云产品监控')}
          </MenuItem>
          <MenuTitle>{_$('Prometheus监控')}</MenuTitle>
          <MenuItem
            key="/monitor/prometheusmonitor/instanceList"
            to="/monitor/prometheusmonitor/instanceList"
          >
            {_$('实例列表')}
          </MenuItem>
          <MenuItem
            key="/monitor/prometheusmonitor/metricexplore"
            to="/monitor/prometheusmonitor/metricexplore"
          >
            {_$('指标探索')}
          </MenuItem>
          <MenuItem key="/monitor/prometheusmonitor/alarm" to="/monitor/prometheusmonitor/alarm">
            {_$('告警管理')}
          </MenuItem>
          <MenuTitle>{_$('Grafana服务')}</MenuTitle>
          <MenuItem key="/monitor/grafana/instancelist" to="/monitor/grafana/instancelist">
            {_$('实例信息')}
          </MenuItem>
          <MenuTitle>{_$('自定义监控')}</MenuTitle>
          <MenuItem key="/monitor/custom/metric" to="/monitor/custom/metric">
            {_$('指标')}
          </MenuItem>
          <MenuItem key="/monitor/custom/alarm" to="/monitor/custom/alarm">
            {_$('警报')}
          </MenuItem>
          <MenuTitle>{_$('告警服务')}</MenuTitle>
          <MenuItem key="/monitor/alarmServer/rule/home" to="/monitor/alarmServer/rule/home">
            {_$('告警策略')}
          </MenuItem>
          <MenuItem key="/monitor/alarmServer/history/home" to="/monitor/alarmServer/history/home">
            {_$('告警历史')}
          </MenuItem>
          <MenuItem
            key="/monitor/alarmServer/alarming/home"
            to="/monitor/alarmServer/alarming/home"
          >
            {_$('正在告警')}
          </MenuItem>
          <MenuItem
            key="/monitor/alarmServer/template/home"
            to="/monitor/alarmServer/template/home"
          >
            {_$('触发条件模版')}
          </MenuItem>
          <MenuItem
            key="/monitor/alarmServer/silences/home"
            to="/monitor/alarmServer/silences/home"
          >
            {_$('告警屏蔽')}
          </MenuItem>
          <MenuItem key="/monitor/alarmServer/alertTarget" to="/monitor/alarmServer/alertTarget">
            {_$('通知对象')}
          </MenuItem>
          <MenuTitle>{_$('自动化运维')}</MenuTitle>
          <MenuItem key="/monitor/eventops/trigger" to="/monitor/eventops/trigger">
            {_$('触发器')}
          </MenuItem>
          <MenuItem key="/monitor/eventops/scene" to="/monitor/eventops/scene">
            {_$('自动化场景')}
          </MenuItem>
          <MenuItem key="/monitor/eventops/record" to="/monitor/eventops/record">
            {_$('执行记录')}
          </MenuItem>
          <MenuItem key="/monitor/eventops/functions" to="/monitor/eventops/functions">
            {_$('公共函数')}
          </MenuItem>
          <Divider className="divider-style" theme={theme === 'white' ? 'light' : theme} />
          <MenuItem key="/monitor/systomcenter/home" to="/monitor/systomcenter/home">
            {_$('事件中心')}
          </MenuItem>
          <MenuItem key="/monitor/dashboard/home" to="/monitor/dashboard/home">
            {_$('Dashboard')}
          </MenuItem>
          <MenuItem key="/monitor/group/home" to="/monitor/group/home">
            {_$('资源分组')}
          </MenuItem>
        </Menu>
      ) : null}
    </div>
  )
}
const SiderBar = withRouter(RouterBar)
export default styled(SiderBar)`
  padding-top: 50px;
  position: fixed;
  top: 0;
  height: 100vh;
  background: #fff;
  z-index: 99;
  .k-menu {
    height: 100%;
  }
  .divider-style {
    margin: 4px 0;
  }
`
